

























































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'
import { InputMedicineValues } from './MedicineModal.vue'
import { InputeMedicineItem } from './DispensationCreateForm.vue'

@Component({
  components: {
    HiddenInput: () => import('@/components/common/inputs/HiddenInput.vue'),
    NumberInput: () => import('@/components/common/inputs/NumberInput.vue'),
    TextInput: () => import('@/components/common/inputs/TextInput.vue'),
    MedicineModal: () => import('./MedicineModal.vue')
  }
})
export default class MedicineInputGroup extends mixins(InputGroup) {
  @Prop(Object) inputMedicine!: InputeMedicineItem
  @Prop(Boolean) remainingOnlyOneItem!: boolean

  showMedicineSelectModal = false

  handleClickShowMedicineSelectModal() {
    this.showMedicineSelectModal = true
  }

  handleCloseMedicineSelectModal() {
    this.showMedicineSelectModal = false
  }

  handleDecideMedicineSelectModal({
    productName,
    yjCode
  }: InputMedicineValues) {
    this.inputMedicine.medicineName = productName
    this.inputMedicine.medicineCode = yjCode
    this.showMedicineSelectModal = false
  }

  handleRemoveItemButton() {
    this.$emit('removeItem')
  }

  handleAddItemButton() {
    this.$emit('addItem')
  }
}
